import { createPageAnalyticsFn } from 'src/libs/Analytics';
import type { TrackingExperimentsAttributes } from 'src/utils/eventsTypes';

type CandidateManagementLinkAnalyticEvents =
  | {
      event: 'searched_location_pressed';
      attributes: {
        searchLocationId: string[];
        locationIdSelected: string;
        filterSelection: 'Selected' | 'Deselected';
      };
    }
  | {
      event: 'searched_nationality_pressed';
      attributes: {
        searchNationalityId: string[];
        nationalityIdSelected: string;
        filterSelection: 'Selected' | 'Deselected';
      };
    }
  | {
      event: 'candidate_management_freemium_pop_up_displayed';
      attributes: {
        seekListingId: number;
        alertShownMessageCode:
          | 'Candidate Management - Freemium Upgrade - Hard to Fill'
          | 'Candidate Management - Freemium Upgrade - Urgent Hiring';
      };
    }
  | {
      event: 'candidate_management_freemium_pop_up_upgrade_pressed';
      attributes: {
        seekListingId: number;
        alertShownMessageCode:
          | 'Candidate Management - Freemium Upgrade - Hard to Fill'
          | 'Candidate Management - Freemium Upgrade - Urgent Hiring';
      };
    }
  | {
      event: 'alert_dismiss_pressed';
      attributes: {
        seekListingId: number;
        alertShownMessageCode:
          | 'Candidate Management - Freemium Upgrade - Hard to Fill'
          | 'Candidate Management - Freemium Upgrade - Urgent Hiring';
      };
    }
  | {
      event: 'banner_content_pressed';
      attributes: {
        seekListingId: number;
        experiments?: TrackingExperimentsAttributes[];
        bannerElement: 'Let us know';
        displayedBanner: 'Candidate Management - Placement - Have you Placed a Candidate';
      };
    }
  | {
      event: 'dialog_dismiss_pressed';
      attributes: {
        seekListingId: number;
        experiments?: TrackingExperimentsAttributes[];
        dialogName:
          | 'Candidate Management - Placement - Have you Placed'
          | 'Candidate Management - Placement - Improve Job Ad'
          | 'Candidate Management - Placement - Thanks for Helping';
      };
    }
  | {
      event: 'option_selection_pressed';
      attributes: {
        seekListingId: number;
        experiments?: TrackingExperimentsAttributes[];
        optionSelected: 'Yes' | 'No' | 'Not Yet';
        optionSelectionType: 'radio';
        dialogName: 'Candidate Management - Placement - Have you Placed';
        prospectInboxCount: number;
        prospectPrescreenCount: number;
        prospectShortlistCount: number;
        prospectInterviewCount: number;
        prospectOfferCount: number;
        prospectAcceptCount: number;
        prospectNotSuitableCount: number;
      };
    }
  | {
      event: 'view_report_pressed';
      attributes: {
        seekListingId: number;
        experiments?: TrackingExperimentsAttributes[];
        linkAction: 'Redirect to Report';
        linkText: 'View report';
        dialogName: 'Candidate Management - Placement - Improve Job Ad';
      };
    };
type CandidateManagementViewAnalyticEvents =
  | {
      event: 'candidate_management_freemium_pop_up_displayed';
      attributes: {
        seekListingId: number;
        alertShownMessageCode:
          | 'Candidate Management - Freemium Upgrade - Hard to Fill'
          | 'Candidate Management - Freemium Upgrade - Urgent Hiring';
      };
    }
  | {
      event: 'candidate_management_banner_displayed';
      attributes: {
        seekListingId: number;
        experiments?: TrackingExperimentsAttributes[];
        displayedBanner: 'Candidate Management - Placement - Have you Placed a Candidate';
      };
    }
  | {
      event: 'dialog_displayed';
      attributes: {
        seekListingId: number;
        experiments?: TrackingExperimentsAttributes[];
        dialogName:
          | 'Candidate Management - Placement - Have you Placed'
          | 'Candidate Management - Placement - Improve Job Ad'
          | 'Candidate Management - Placement - Thanks for Helping';
      };
    };

export const createPageAnalytics = createPageAnalyticsFn<
  CandidateManagementLinkAnalyticEvents,
  CandidateManagementViewAnalyticEvents
>({
  siteSubsection: 'candidate',
});
